import styled from 'styled-components';

import InlineDateUpdate from './InlineDateUpdate';

export default styled(InlineDateUpdate)`
  .inline-date_update {
    &__edit {
      align-items: center;
      justify-content: center;
      width: 26em;
      display: flex;
    }

    &__date-field {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__edit * {
      display: flex;
      margin-bottom: 0;
    }

    &__edit {
      #day {
        width: 3.5em;
      }
      #month {
        width: 3.5em;
      }
      #year {
        width: 4em;
      }
      button {
        margin-left: 1em;
      }
    }

    &__empty {
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
